import React from 'react';
import ScoringWorkflowDiagram from '../components/ScoringWorkflowDiagram';
import AppLayout from '../components/Layout/AppLayout';
import FeatureCardsGrid from '../components/FeatureCardsGrid';
import { AuroraText } from '../components/ui/aurora-text';

const ArchitectureVisualizationPage: React.FC = () => {
  return (
    <AppLayout
      pageTitle="How It Works"
      breadcrumb="How It Works"
    >
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
        <div className="mt-16 mb-16 text-center">
          {/* Main Headline with integrated branding */}
          <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-6 tracking-tight" style={{ fontFamily: 'var(--font-family-heading)', fontWeight: '800', lineHeight: '1.1' }}>
            <AuroraText colors={["#FF6B00", "#D14900", "#FF9900", "#8B3A00"]}>
              <span style={{ fontFamily: 'var(--font-family-heading)', fontWeight: '800' }}>talrev.</span>
            </AuroraText>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8" style={{ fontSize: 'var(--font-size-lg)' }}>
            Your talent review companion.
            <br />
            Let AI Agents read guidelines, reconcile feedback, and reduce bias.
            <br />
            <span className="font-semibold text-gray-800">Fine-tuned and calibrated to support your decisions.</span>
          </p>

          {/* Trust Badge */}
          <div className="inline-flex items-center gap-4 px-6 py-3 bg-white border border-gray-200 rounded-full shadow-sm">
            <div className="flex -space-x-3">
              <img
                src="https://api.dicebear.com/7.x/lorelei/svg?seed=Alex"
                alt="Team member"
                className="w-10 h-10 rounded-full border-2 border-white ring-1 ring-gray-100"
              />
              <img
                src="https://api.dicebear.com/7.x/lorelei/svg?seed=Jamie"
                alt="Team member"
                className="w-10 h-10 rounded-full border-2 border-white ring-1 ring-gray-100"
              />
              <img
                src="https://api.dicebear.com/7.x/lorelei/svg?seed=Morgan"
                alt="Team member"
                className="w-10 h-10 rounded-full border-2 border-white ring-1 ring-gray-100"
              />
            </div>
            <span className="text-base font-medium text-gray-700 flex items-center gap-2" style={{ fontSize: 'var(--font-size-base)' }}>
              Built by
              <img
                src="/AWS_logo_RGB_1c_Gray850.svg"
                alt="AWS"
                className="h-4 inline-block"
              />
              Enterprise Support
            </span>
          </div>
        </div>

        {/* App Preview Image with Gradient Fade */}
        <div className="mb-16 relative rounded-2xl overflow-hidden shadow-lg">
          <img
            src="/review_sample.png"
            alt="TalRev Application Preview"
            className="w-full h-auto"
          />
          {/* White gradient fade at bottom */}
          <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        </div>

        {/* Feature Cards Grid */}
        <FeatureCardsGrid />

        <div className="mt-8 bg-white rounded-lg shadow-sm border overflow-hidden">
          <div className="p-4 border-b bg-gray-50">
            <h2 className="text-lg font-semibold text-gray-800">
              Scoring Workflow: How It Works
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              This interactive diagram shows the complete agentic scoring pipeline from document input to final insights.
              Click nodes for details, drag to pan, and use zoom controls to explore.
            </p>
          </div>

          <div className="relative">
            <ScoringWorkflowDiagram />
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default ArchitectureVisualizationPage;